import type { CarFinanceProps } from "@interfaces/CarFinance.types";

export const getCarFinanceData = (props: CarFinanceProps) => {
  const {
    isLoggedIn = false,
    savingsBreakupData,
    onRoadPrice,
    carFinanceValuePropositions = [],
    carFinanceData,
    carFinanceBankData = [],
    selectedBankValue,
    maxSavings,
    brandName,
    modelName,
    variantName,
    pageType,
    isSellable,
    cityName,
    carAvailability,
  } = props;

  return {
    isLoggedIn,
    savingsBreakupData,
    onRoadPrice,
    carFinanceData,
    carFinanceBankData,
    selectedBankValue,
    maxSavings,

    brandName,
    modelName,
    variantName,
    cityName,
    isSellable,
    carAvailability,
    pageType,
    carFinanceValuePropositions,
    defaultValues: {
      initialDuration: 7,
      minTenure: 2,
      maxTenure: 7,
      minInterestRate: 6.4,
      maxInterestRate: 20,
      minDownPaymentPercentage: 0.1,
      maxDownPaymentPercentage: 0.8,
      defaultDownPaymentPercentage: 0.2,
      tenureOptions: [1, 2, 3, 4, 5, 6, 7],
    },
    modalConfig: {
      downpayment: {
        title: "Select your down payment amount",
        inputLabel: "Down Payment",
        inputPrefix: "₹",
        placeholder: "",
      },
      tenure: {
        title: "Select your loan tenure",
        options: [1, 2, 3, 4, 5, 6, 7],
      },
      interest: {
        title: "Select loan rate of interest",
        inputLabel: "Other dealer interest (optional)",
        inputPrefix: "%",
        placeholder: "Other dealer interest (optional)",
      },
    },

    validationMessages: {
      invalidAmount: "Please enter a valid amount",
      invalidNumber: "Please enter a valid number",
      invalidFormat: "Invalid input format",
      invalidDecimal: "Invalid decimal format",
      maxDecimalPlaces: "Maximum 2 decimal places allowed",
      completeDecimal: "Please complete the decimal value",
      minInterest: "Minimum interest rate possible is 6.4%",
      maxInterest: "Maximum interest rate possible is 20%",
      enterInterest: "Please enter an interest rate",
      downpaymentExceedsCarValue: "Down payment cannot exceed the car value",
    },

    storageKeys: {
      loginType: "loginType",
      mmvData: "MMV",
    },

    eventTracking: {
      actionType: "tap_btn",
      actionName: "tap_btn_emi",
    },

    sliderConfig: {
      min: 2,
      max: 7,
      thumbSize: 24,
      trackHeight: 6,
      trackColor: "rgb(240, 240, 246)",
      fillColor: "rgb(140, 233, 154)",
      thumbBackground: "#18183a",
      thumbIcon: "/icons/thumb.svg",
    },
  };
};
